import { createFileRoute } from "@tanstack/react-router";

import { PluginSkillsPage } from "../components/plugins/PluginSkillsPage";

export const Route = createFileRoute("/_chat/plugins/skills")({
  component: PluginSkillsPage,
});
